/* Melinava: Kurzinfo-Karten (Button mit data-mv-trust-open="<id>" öffnet .mv-trust__pop; X, Escape oder Klick daneben schließt).
   Genutzt von snippets/mv-vertrauen.liquid und snippets/mv-titelzeilen.liquid. */
  (function () {
    if (window.mvTrustPop) return;
    window.mvTrustPop = true;
    function closeAll(except) {
      document.querySelectorAll('.mv-trust__pop:not([hidden])').forEach(function (p) {
        if (p === except) return;
        p.hidden = true;
        var b = document.querySelector('[data-mv-trust-open="' + p.id + '"]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-mv-trust-open]');
      if (open) {
        var pop = document.getElementById(open.getAttribute('data-mv-trust-open'));
        var show = pop.hidden;
        closeAll(pop);
        pop.hidden = !show;
        open.setAttribute('aria-expanded', show ? 'true' : 'false');
        if (show) pop.querySelector('[data-mv-trust-close]').focus({ preventScroll: true });
        return;
      }
      if (e.target.closest('[data-mv-trust-close]')) {
        var p = e.target.closest('.mv-trust__pop');
        closeAll();
        var b = document.querySelector('[data-mv-trust-open="' + p.id + '"]');
        if (b) b.focus({ preventScroll: true });
        return;
      }
      if (!e.target.closest('.mv-trust__pop')) closeAll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  })();
